export const ACTION_PREFIX_PARAMETER = 'parameter'